import React, { useEffect, useState } from "react";
import { InputGroup, Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";

import { useMutation } from "@apollo/client";
import { Formik, Form, Field, useFormik } from "formik";

import { Input, Select } from "../../../../_metronic/_partials/controls";
import { TOKEN } from "../../../Utils/constant";
import * as auth from "../_redux/authRedux";
import { COMPANY_EDIT_MUTATION } from "../mutations/index";

import { useOrganizationValidationSchema } from "./useOrganizationValidationSchema";

export function OrganizationModal() {
  const { initialValues, organizationValidationSchema } = useOrganizationValidationSchema();

  const [actionsLoading, setActionsLoading] = useState(false);

  const [
    companySubmit,
    { loading: companyLoading, error: companyError, data },
  ] = useMutation(COMPANY_EDIT_MUTATION);

  const dispatch = useDispatch();

  const formik = useFormik({
    initialValues,
    validationSchema: organizationValidationSchema,
  });

  useEffect(() => {
    if (companyLoading) {
      setActionsLoading(true);
    }

    if (companyError) {
      setActionsLoading(false);
      formik.setStatus(companyError.toString().replace("Error: Error:", ""));
    }

    if (data) {
      const token = window.localStorage.getItem(TOKEN);

      const user = JSON.parse(window.localStorage.getItem("user"));

      dispatch(auth.actions.login(token));
      dispatch(
        auth.actions.fulfillUser({
          ...user,
          username: user.firstName,
          fullname: user.firstName,
        }),
      );
    }
  }, [companyLoading, companyError, data, formik, dispatch]);

  const saveCompany = (company, setSubmitting) => {
    companySubmit({
      variables: {
        name: company.companyName,
        city: company.city,
        state: company.state,
        zipcode: company.zipcode,
        companyType: company.companyType,
        apt: company.apt || " ",
        street: company.street,
        country: company.country,
        domain: company.domain,
        contact: company.phonenumber || " ",
      },
    });
    setSubmitting(false);
  };

  return (
    <Modal
      className="modal_custom"
      size="lg"
      show={true}
      aria-labelledby="example-modal-sizes-title-lg"
    >
      <>
        <Formik
          enableReinitialize={true}
          initialValues={initialValues}
          validationSchema={organizationValidationSchema}
          onSubmit={(values, { setSubmitting }) => {
            saveCompany(values, setSubmitting);
          }}
        >
          {({ handleSubmit }) => (
            <>
              <Modal.Body className="overlay overlay-block cursor-default modal_style_custom">
                {actionsLoading && (
                  <div className="overlay-layer bg-transparent">
                    <div className="spinner spinner-lg spinner-success" />
                  </div>
                )}
                {formik.status && (
                  <div className="mb-10 alert alert-custom alert-light-danger alert-dismissible">
                    <div className="alert-text font-weight-bold">
                      {formik.status}
                    </div>
                  </div>
                )}

                <div className="modal_style_custom_header">
                  <h4>Organization Profile</h4>
                </div>

                <Form className="form form-label-right">
                  <div className="form-group row">
                    {/* Organization Name */}
                    <div className="col-lg-6">
                      <Field
                        name="companyName"
                        component={Input}
                        placeholder="Organization Name"
                        label="Organization Name"
                      />
                    </div>
                    {/* City */}
                    <div className="col-lg-6">
                      <Field
                        name="city"
                        component={Input}
                        placeholder="City"
                        label="City"
                      />
                    </div>
                  </div>
                  {/* Domain */}
                  <div className="form-group row">
                    <div className="col-lg-6">
                      <Field
                        name="domain"
                        component={Input}
                        placeholder="Domain"
                        label="Domain"
                      />
                      <InputGroup.Append
                        style={{
                          position: "absolute",
                          right: "20px",
                          top: "29%",
                        }}
                      >
                        <InputGroup.Text id="basic-addon2">
                          @equipbid.com
                        </InputGroup.Text>
                      </InputGroup.Append>
                    </div>

                    {/* State */}
                    <div className="col-lg-4 pr-1">
                      <Select name="state" label="State/province">
                        <option value="california">California</option>
                        <option value="alaska">Alaska</option>
                      </Select>
                    </div>
                    {/* Zip code */}
                    <div className="col-lg-2 pl-1 zip_code_custom">
                      <Field
                        type="number"
                        name="zipcode"
                        component={Input}
                        placeholder="Zip Code"
                        label="Zip Code"
                      />
                    </div>
                  </div>

                  <div className="form-group row">
                    <div className="col-lg-6">
                      <Field
                        type="number"
                        name="phonenumber"
                        component={Input}
                        placeholder="Phone number(optional)"
                        label="Phone number"
                      />
                    </div>
                    {/* Street */}
                    <div className="col-lg-6">
                      <Field
                        type="text"
                        name="street"
                        component={Input}
                        placeholder="Street"
                        label="Street"
                      />
                    </div>
                  </div>
                  <div className="form-group row">
                    {/* Country */}
                    <div className="col-lg-6">
                      <Select name="country" label="Country">
                        <option value="">Country</option>
                        <option value="canada">Canada</option>
                      </Select>
                    </div>

                    {/* Organization type */}
                    <div className="col-lg-6">
                      <Select name="companyType" label="Organization Type">
                        <option value="type1">Type 1</option>
                        <option value="type2">Type 2</option>
                      </Select>
                    </div>
                  </div>
                  <div className="form-group row">
                    <div className="col-lg-6">
                      <Field
                        type="text"
                        name="apt"
                        component={Input}
                        placeholder="Apt, Suite, Bldg(Optional)"
                        label="Apt, Suite, Bldg"
                      />
                    </div>
                  </div>
                </Form>
              </Modal.Body>
              <Modal.Footer className="modal_style_custom_footer">
                <button
                  type="submit"
                  onClick={handleSubmit}
                  disabled={formik.isSubmitting}
                  className={
                    "btn btn-primary btn-elevate modal_style_custom_submit font-weight-bold px-9 py-4"
                  }
                >
                  Submit
                  {actionsLoading && (
                    <span className="ml-3 spinner spinner-white"></span>
                  )}
                </button>
              </Modal.Footer>
            </>
          )}
        </Formik>
      </>
    </Modal>
  );
}
